import { useAutoNavigate, useGraphQLMutation } from '@betterment/js-runtime';

import { EditUserLevelSettingsDocument } from '../graphql/mutation.editUserLevelSettings.generated';

export const useEditUserLevelSettings = (returnToPath?: string) => {
  const autoNavigate = useAutoNavigate();
  const [updateSecuritiesLendingEnrollment] = useGraphQLMutation(EditUserLevelSettingsDocument);

  const handleUpdate = async (isEnrolled: boolean) => {
    const result = await updateSecuritiesLendingEnrollment({
      variables: {
        input: {
          isEnrolled,
        },
      },
    });

    if (result.data?.updateSecuritiesLendingEnrollment.result?.securityLending?.status) {
      if (returnToPath) {
        return autoNavigate(returnToPath);
      }

      return result.data.updateSecuritiesLendingEnrollment.result.securityLending.status;
    }

    return null;
  };

  return {
    update: handleUpdate,
  };
};
